import { RadioGroup, Radio } from "@headlessui/react";
import { cn } from "src/utils/cn";

type SegmentedToggleProps<Value> = {
  options: {
    name: string | React.ReactNode;
    value: Value;
  }[];
  selectedValue: Value;
  onChange: (value: Value) => void;
  disabled?: boolean;
  // will show the component as disabled, but it won't actually be disabled
  showAsDisabled?: boolean;
  className?: string;
};

export function SegmentedToggle<Value>({
  options,
  selectedValue,
  onChange,
  disabled = false,
  showAsDisabled = false,
  className = "",
}: SegmentedToggleProps<Value>) {
  return (
    <RadioGroup
      value={selectedValue}
      onChange={onChange}
      className="flex w-full items-center justify-between rounded-full bg-gray-200 p-1"
      disabled={disabled}
    >
      {options.map((option) => (
        <Radio
          key={String(option.value)}
          value={option.value}
          className={cn(
            `relative flex w-full justify-center truncate rounded-full px-6 py-2 transition duration-200 ease-in-out sm:px-8 md:px-4 lg:px-6`,
            selectedValue === option.value
              ? `rounded-full bg-red-500 text-white`
              : `text-gray-500`,
            disabled || showAsDisabled
              ? `cursor-default opacity-50`
              : `cursor-pointer`,
            className
          )}
        >
          {option.name}
        </Radio>
      ))}
    </RadioGroup>
  );
}
